<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="serverError === null">

  <h2 *ngIf="loadingEventType">
    Loading...
  </h2>

  <ng-container *ngIf="!loadingEventType">

    <h2>
      Waitlist for {{ eventType.name }}
      <span *ngIf="loadingWaitlistEntries" class="text-secondary">
        - Loading...
      </span>
      <span *ngIf="!loadingWaitlistEntries && waitListEntryResult">
        ({{ waitListEntryResult.count.toLocaleString() }})
      </span>
    </h2>

    <div class="row">
      <div class="col-lg-6 col-12 mb-3">
        <input type="text" class="form-control"
               placeholder="Filter waitlist by name, email"
               [(ngModel)]="search"
               (ngModelChange)="pageNumber = 1; loadWaitlistPageSubject.next();">
      </div>
      <div class="col-lg-6 col-12 mb-3">
        <select class="custom-select w-auto"
                [(ngModel)]="isActive"
               (ngModelChange)="pageNumber = 1; loadWaitlistPageSubject.next();">
          <option [ngValue]="true">
            Show active waitlist entries
          </option>
          <option [ngValue]="false">
            Show resolved waitlist entries
          </option>
        </select>
      </div>
    </div>

    <div class="rounded-table-wrapper rounded-table-tight table-responsive"
         #waitlistTableWrapper>
      <table class="table table-12px" style="border-collapse: separate; border-spacing: 0;">

        <thead>
        <tr class="position-relative">
          <th scope="col" colspan="99" class="text-primary p-0" style="font-size: 16px;">
            <div style="padding-left: 12px; padding-right: 12px; position: sticky; left: 0;"
                 #waitlistTableTitleContainer>
              <div class="d-inline-block" style="margin-top: 13px;">
                <span>Event Type Waitlist</span>
              </div>
              <div class="float-right" style="margin-top: 8px; margin-bottom: 8px;">
                <button (click)="openAddToWaitlistModal()"
                        class="btn btn-sm btn-outline-primary mr-2"
                        style="font-size: 12px; line-height: 12px;">
                  Add To Waitlist
                </button>
                <button (click)="openExportWaitlistModal()"
                        class="btn btn-sm btn-outline-primary"
                        style="font-size: 12px; line-height: 12px;">
                  Export Waitlist
                </button>
              </div>
            </div>
          </th>
        </tr>
        <tr>
          <th scope="col" class="customer-name-column">Name</th>
          <th scope="col"></th>
          <th scope="col">Waitlist Status</th>
          <th scope="col" *ngIf="eventType.allow_waitlist_customers_to_select_preferred_days_of_week">
            Preferred Days
          </th>
          <th scope="col" *ngIf="eventType.allow_waitlist_customers_to_select_preferred_locations">
            Preferred Locations
          </th>
          <th scope="col">Date Added</th>
          <th scope="col">Last Activity</th>
          <th scope="col">Age</th>
          <th scope="col">Notification Email</th>
          <th scope="col">Added By</th>
        </tr>
        </thead>

        <tbody *ngIf="resultsPresent()">
        <tr *ngFor="let entry of waitListEntryResult.results">

          <td *ngIf="entry.participant_customer_id" class="customer-name-column pb-0 text-nowrap" style="padding-top: 6px">
            <div style="padding-top: 6px; padding-right: 2px;" class="d-inline-block">
              <a routerLink="/customers/{{ entry.participant_customer_id }}">
                {{ entry.last_name }}, {{ entry.first_name }}
              </a>
            </div>
            <div class="d-inline-block text-muted" *ngIf="loadingCustomerProfileDetails[entry.participant_customer_id]">
              Loading...
            </div>
            <div class="d-inline-block" *ngIf="!loadingCustomerProfileDetails[entry.participant_customer_id]">
              <div *ngIf="customer[entry.participant_customer_id] && customer[entry.participant_customer_id].has_medical_notes"
                   ngbTooltip="Has medical notes"
                   class="d-inline">
                <app-medical-notes-icon [size]="0"></app-medical-notes-icon>
              </div>
              <div *ngIf="customerProfileDetails[entry.participant_customer_id] && customerProfileDetails[entry.participant_customer_id].has_alert_icon"
                   ngbTooltip="Has a profile alert"
                   class="d-inline">
                <app-alert-icon [size]="0"></app-alert-icon>
              </div>
              <div *ngFor="let proficiency of getCustomerProficienciesForId(entry.participant_customer_id)"
                   class="d-inline"
                   [ngbTooltip]="proficiency.proficiency_name">
                <app-proficiency-icon [colorHex]="proficiency.proficiency_icon_color_hex"
                                      [iconInitials]="proficiency.proficiency_icon_initials"
                                      [size]="0">
                </app-proficiency-icon>
              </div>
              <div *ngFor="let icon of getCustomerMembershipIconsForId(entry.participant_customer_id)"
                   class="d-inline"
                   [ngbTooltip]="icon.icon_hover_text">
                <app-membership-icon [colorHex]="icon.icon_color_hex"
                                     [iconInitials]="icon.icon_initials"
                                     [size]="0"
                                     style="padding-right:1px">
                </app-membership-icon>
              </div>
            </div>
          </td>
          <td *ngIf="!entry.participant_customer_id" class="customer-name-column text-nowrap">
            {{ entry.last_name }}, {{ entry.first_name }}
          </td>

          <td class="table-12px-button-cell">
            <div class="dropdown dropright"
                 *ngIf="entry.status !== SEStatus.accepted">
              <button class="btn btn-sm btn-secondary table-12px-button dropdown-toggle position-relative"
                      type="button" id="manageWaitlistEntryDropdown{{ entry.id }}"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Manage
              </button>
              <div class="dropdown-menu" attr.aria-labelledby="manageWaitlistEntryDropdown{{ entry.id }}">
                <ng-container *ngIf="entry.status === SEStatus.waiting">
                  <a class="dropdown-item" href="#"
                     (click)="openInviteToBookModal(entry);$event.preventDefault();">
                    Invite Off Waitlist
                  </a>
                  <a class="dropdown-item" href="#"
                     *ngIf="eventType.schedule_type === ScheduleType.rolling"
                     (click)="openAddToRosterModal(entry);$event.preventDefault();">
                    Add To Roster
                  </a>
                  <a class="dropdown-item" href="#"
                     (click)="openRemoveWaitlistEntryModal(entry);$event.preventDefault();">
                    Remove From Waitlist
                  </a>
                </ng-container>
                <a class="dropdown-item" href="#"
                   *ngIf="(entry.status === SEStatus.pending) && (entry.event)"
                   (click)="handleCompleteBooking(entry);$event.preventDefault();">
                  Complete Booking
                </a>
                <a class="dropdown-item" href="#"
                   *ngIf="(entry.status === SEStatus.pending) && (entry.roster)"
                   (click)="handlePurchaseRosterMembership(entry);$event.preventDefault();">
                  Purchase Roster Membership
                </a>
                <a class="dropdown-item" href="#"
                   *ngIf="entry.status === SEStatus.pending"
                   (click)="openInviteToBookModal(entry);$event.preventDefault();">
                  Resend Invitation
                </a>
                <a class="dropdown-item" href="#"
                   *ngIf="entry.status === SEStatus.pending"
                   (click)="openModifyPendingEntryModal(entry);$event.preventDefault();">
                  Modify
                </a>
                <!--suppress TypeScriptValidateTypes -->
                <a class="dropdown-item" href="#"
                   *ngIf="[SEStatus.expired, SEStatus.rejected].includes(entry.status)"
                   (click)="openInviteToBookModal(entry);$event.preventDefault();">
                  Re-invite To Book
                </a>
              </div>
            </div>
          </td>

          <td style="line-height: 14px">
            <span *ngIf="entry.status === SEStatus.waiting">
              Waiting
            </span>
            <span *ngIf="entry.status === SEStatus.pending">
              <span class="text-warning">Pending</span>
              <span *ngIf="entry.booking_deadline !== null" class="text-nowrap">
                (Exp
                {{ dateStringFromISO8601(entry.booking_deadline, entry.time_zone) }},
                {{ timeStringFromISO8601(entry.booking_deadline, entry.time_zone) }})
              </span>
              <span *ngIf="entry.booking_deadline === null" class="text-nowrap">
                (No expiration)
              </span>
            </span>
            <span *ngIf="entry.status === SEStatus.accepted" class="text-success">
              Accepted
            </span>
            <span *ngIf="entry.status === SEStatus.expired">
              <span class="text-danger">Expired</span>
              <span *ngIf="entry.booking_deadline !== null" class="text-nowrap">
                (Exp
                {{ dateStringFromISO8601(entry.booking_deadline, entry.time_zone) }},
                {{ timeStringFromISO8601(entry.booking_deadline, entry.time_zone) }})
              </span>
            </span>
            <span *ngIf="entry.status === SEStatus.rejected" class="text-danger">
              Rejected
            </span>

            <ng-container *ngIf="entry.roster">
              <br>
              Roster: {{ entry.roster.name }}
              <br>
              <span *ngIf="entry.start_date" class="text-nowrap">
                Start Date: {{ dateStringFromISO8601(entry.start_date) }}
              </span>
              <span *ngIf="!entry.start_date" class="text-muted text-nowrap"
                    ngbTooltip="No start date was set on this invite. The customer chooses one at purchase if the membership allows it, otherwise the membership starts on the day it is purchased."
                    container="body">
                Start Date: Not set
              </span>
            </ng-container>
          </td>

          <td *ngIf="eventType.allow_waitlist_customers_to_select_preferred_days_of_week">
            <span *ngIf="entry.preferred_days_of_week">
              {{ entry.preferred_days_of_week }}
            </span>
            <span *ngIf="!entry.preferred_days_of_week" class="text-muted">
              None provided
            </span>
          </td>

          <td style="line-height: 14px"
              *ngIf="eventType.allow_waitlist_customers_to_select_preferred_locations">
            <ng-container *ngIf="entry.preferred_locations">
              <span *ngIf="locationService.getLocations() === null" class="text-muted">
                Loading...
              </span>
              <ng-container *ngIf="locationService.getLocations() !== null">
                <ng-container *ngFor="let locName of getPreferredLocationNames(entry)">
                  {{ locName }} <br>
                </ng-container>
              </ng-container>
            </ng-container>
            <span *ngIf="!entry.preferred_locations" class="text-muted">
              None provided
            </span>
          </td>

          <td class="text-nowrap">
            {{ dateStringFromISO8601(entry.waiting_since) }}
          </td>

          <td class="text-nowrap">
            {{ dateStringFromISO8601(entry.updated_at) }},
            {{ timeStringFromISO8601(entry.updated_at) }}
          </td>

          <td>
            <span [ngbTooltip]="'Birthday: ' + dateStringFromISO8601(entry.birthday)">
              {{ getAge(entry.birthday) }}
            </span>
          </td>

          <td>{{ entry.notification_email }}</td>

          <td class="text-nowrap">
            <a *ngIf="entry.booking_customer_id !== null"
               routerLink="/customers/{{ entry.booking_customer_id }}">
              {{ entry.booking_customer_last_name }}, {{ entry.booking_customer_first_name }}
            </a>
            <span *ngIf="entry.booking_customer_id === null" class="text-muted">
              Not Logged In
            </span>
          </td>

        </tr>
        </tbody>

        <tbody>
        <tr *ngIf="!resultsPresent()">
          <td colspan="99">
            {{ loadingWaitlistEntries ? 'Loading...' : 'No waitlist entries' }}
          </td>
        </tr>
        </tbody>

      </table>
    </div>

    <div class="row">
      <div class="col-sm mb-2">
        <label for="resultsPerPage" class="pr-1 align-middle">
          Results per page:
        </label>
        <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
                [(ngModel)]="eventTypeWaitlistPageSize"
                (change)="pageNumber = 1;loadWaitlistPageSubject.next();">
          <option [ngValue]="10">10</option>
          <option [ngValue]="25">25</option>
          <option [ngValue]="50">50</option>
          <option [ngValue]="100">100</option>
        </select>
      </div>
      <div class="col-sm">
        <nav aria-label="Pagination">
          <ul class="pagination justify-content-end">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
                 (click)="setPage(pageNumber - 1)">
                <span aria-hidden="true">&laquo;</span>
              </button>
            </li>
            <li class="page-item" *ngIf="pageNumber > 2">
              <button class="page-link" (click)="setPage(pageNumber - 2)">
                {{ pageNumber - 2 }}
              </button>
            </li>
            <li class="page-item" *ngIf="pageNumber > 1">
              <button class="page-link" (click)="setPage(pageNumber - 1)">
                {{ pageNumber - 1 }}
              </button>
            </li>
            <li class="page-item active" aria-current="page">
              <button class="page-link" disabled>
                {{ pageNumber }}
                <span class="sr-only">(current)</span>
              </button>
            </li>
            <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
              <button class="page-link" (click)="setPage(pageNumber + 1)">
                {{ pageNumber + 1 }}
              </button>
            </li>
            <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
              <button class="page-link" (click)="setPage(pageNumber + 2)">
                {{ pageNumber + 2 }}
              </button>
            </li>
            <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
              <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
                 (click)="setPage(pageNumber + 1)">
                <span aria-hidden="true">&raquo;</span>
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <div class="floating-alert-container">
      <ng-container *ngIf="modalResult">
        <div class="alert alert-success alert-dismissible" role="alert"
             *ngIf="modalResult.status === CallbackResultStatus.success">
          {{ modalResult.text }}
          <button type="button" class="close" (click)="modalResult = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="alert alert-danger alert-dismissible" role="alert"
             *ngIf="modalResult.status === CallbackResultStatus.error">
          {{ modalResult.text }}
          <button type="button" class="close" (click)="modalResult = null">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </ng-container>
    </div>

  </ng-container>

</div>
